/* eslint-disable no-nested-ternary */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import MDBox from "components/MDBox";
import React from "react";
import Loader from "utils/Loader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { displayDate } from "utils/Date";
import { useSelector } from "react-redux";
import moment from "moment";
import "../../../../../styles/coachup.scss";

function ListingTable({ payload, setPayload, reports, status, count }) {
  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.only("xs"));
  const navigate = useNavigate();
  const loginUserState = useSelector((state) => state.loginUser.loginUserState);
  const handlePageChange = (_, newPage) => {
    setPayload((prevPayload) => ({ ...prevPayload, pageNumber: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  const getRowIcon = (row) => {
    if (status === "Open") {
      return row?.createdByUser?.id !== loginUserState.id ? (
        <EditIcon
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/coach/reports/view?userId=${row.User.id}&reportId=${row.id}`)}
        />
      ) : (
        <VisibilityIcon
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/coach/reports/view?userId=${row.User.id}&reportId=${row.id}`)}
        />
      );
    }
    return (
      <VisibilityIcon
        style={{ cursor: "pointer" }}
        onClick={() => navigate(`/coach/reports/view?userId=${row.User.id}&reportId=${row.id}`)}
      />
    );
  };

  return (
    <MDBox sx={{ position: "relative" }}>
      <Loader loading={false} />
      <TableContainer component={Paper} className="coachup-datatable">
        <Table aria-label="simple table">
          {!isMobileDisplay && (
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow className="user-table-header">
                <TableCell sx={{ minWidth: "100px" }}>Report Type</TableCell>
                <TableCell align="center">
                  {status === "Open" ? "Due Date" : "Completed Date"}
                </TableCell>
                <TableCell align="center">
                  {status === "Open" ? "Requested By" : "Submitted By"}
                </TableCell>
                {status === "Open" && <TableCell align="center">Status</TableCell>}
                <TableCell width="80px" />
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {reports?.map((row) => (
              <TableRow
                key={row.id}
                hover
                onClick={() =>
                  !isMobileDisplay &&
                  navigate(`/coach/reports/view?userId=${row.User.id}&reportId=${row.id}`)
                }
              >
                {isMobileDisplay ? (
                  <>
                    <TableCell
                      sx={{
                        borderLeft: `5px solid ${row?.CoachupTemplate?.color}`,
                      }}
                    >
                      <Stack direction="column">
                        <Typography>{row?.CoachupTemplate?.name}</Typography>
                        <Box className="datatable-box" alignItems="baseline">
                          <Typography className="datatable-mobile-label">
                            {status === "Open" ? "Due" : "Completed"}
                          </Typography>
                          <Typography className="datatable-mobile-value">
                            {status === "Open"
                              ? displayDate(moment.tz(row.dueDate, loginUserState.timezone))
                              : displayDate(
                                  moment.tz(row.managerCompletedDate, loginUserState.timezone)
                                )}
                          </Typography>
                        </Box>
                        <Box className="datatable-box" alignItems="baseline">
                          <Typography className="datatable-mobile-label">
                            {status === "Open" ? "Requested By" : "Submitted By"}
                          </Typography>
                          <Typography className="datatable-mobile-value">
                            {row.statusId === "Open" ? row?.createdByUser?.name : row?.User?.name}
                          </Typography>
                        </Box>
                        {status === "Open" && (
                          <Box className="datatable-box" alignItems="baseline">
                            <Typography className="datatable-mobile-label">Status</Typography>
                            <Typography className="datatable-mobile-value">
                              {row?.statusId}
                            </Typography>
                          </Box>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell width="40px">{getRowIcon(row)}</TableCell>
                  </>
                ) : (
                  <>
                    <TableCell
                      sx={{
                        borderLeft: `5px solid ${row?.CoachupTemplate?.color}`,
                      }}
                    >
                      {row?.CoachupTemplate?.name}
                    </TableCell>
                    <TableCell align="center">
                      {status === "Open"
                        ? displayDate(moment.tz(row.dueDate, loginUserState.timezone))
                        : displayDate(moment.tz(row.managerCompletedDate, loginUserState.timezone))}
                    </TableCell>
                    <TableCell align="center">
                      {row.statusId === "Open" ? row?.createdByUser?.name : row?.User?.name}
                    </TableCell>
                    {status === "Open" && <TableCell align="center">{row?.statusId}</TableCell>}
                    <TableCell>{getRowIcon(row)}</TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 25, 50]}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          count={count || reports?.length}
          rowsPerPage={payload?.pageSize}
          page={payload?.pageNumber}
          sx={{ flex: "1 1 auto" }}
        />
      </TableContainer>
    </MDBox>
  );
}

export default ListingTable;
